"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _styles = require("../styles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Hourglass = function Hourglass(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/React.createElement(_styles.Svg, {
    width: size,
    height: size,
    fill: "none",
    viewBox: "0 0 13 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className, " ").concat(animation)
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: color,
    d: "M.203.195v1.961h.984v2.942c0 1.3.52 2.547 1.442 3.465A4.931 4.931 0 0 0 6.113 10a4.931 4.931 0 0 0-3.484 1.438 4.89 4.89 0 0 0-1.442 3.464v2.942H.204v1.96H12.02v-1.96h-.985v-2.942c0-1.3-.515-2.547-1.441-3.464A4.922 4.922 0 0 0 6.114 10c.644 0 1.284-.125 1.882-.375a4.888 4.888 0 0 0 1.598-1.063c.457-.453.82-.992 1.066-1.59.25-.593.375-1.23.375-1.874V2.156h.985V.196Zm2.953 1.961h5.91v2.942c0 .78-.312 1.527-.863 2.082a2.97 2.97 0 0 1-4.18 0 2.942 2.942 0 0 1-.867-2.082Zm0 12.746v2.942h5.91v-2.942c0-.78-.312-1.527-.863-2.082a2.97 2.97 0 0 0-4.18 0 2.942 2.942 0 0 0-.867 2.082Zm0 0"
  }));
};
var _default = exports["default"] = Hourglass;